const Customers = ()=>{
    return(
        <>
            <h1>Customers Content</h1>
        </>
    )
}

export default Customers;